export const SHARE_TEMPLATE_TOKENS = [
  { key: "hotel_name", label: "Название отеля" },
  { key: "star_suffix", label: "Звёзды (напр. 3*)" },
  { key: "region_name", label: "Регион" },
  { key: "resort_name", label: "Курорт" },
  { key: "date_entry_short", label: "Заезд (дд.мм)" },
  { key: "date_out_short", label: "Выезд (дд.мм)" },
  { key: "date_entry", label: "Заезд (дд.мм.гггг)" },
  { key: "date_out", label: "Выезд (дд.мм.гггг)" },
  { key: "nights", label: "Кол-во ночей" },
  { key: "food_name", label: "Питание" },
  { key: "type_room_name", label: "Тип комнаты" },
  { key: "room_description", label: "Описание комнаты" },
  { key: "date_depart", label: "Дата вылета" },
  { key: "time_depart", label: "Время вылета" },
  { key: "date_return", label: "Дата обратного рейса" },
  { key: "time_return", label: "Время обратного рейса" },
  { key: "airport_depart_code", label: "Код а/п вылета" },
  { key: "airport_arrival_code", label: "Код а/п прилёта" },
  { key: "price", label: "Цена (базовая)" },
  { key: "final_price", label: "Цена (со скидкой)" },
  { key: "currency", label: "Валюта" },
]
